import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'

import { NAVIGATION } from 'constant/config'

import { useAuthStore } from 'stores/authStore'
import { fixed } from 'helpers/fixed'

import Reference from 'components/Reference'
import Button from 'components/Button'
import Icon from 'components/Icon'

import style from './index.module.scss'

const DATA = [
  NAVIGATION.profile,
  NAVIGATION.wallet,
  NAVIGATION.bonuses,
  NAVIGATION.history,
  NAVIGATION.favourites
]

const AccountMenu = ({ setToggle }) => {
  const { t } = useTranslation()
  const { deleteAuth, auth } = useAuthStore()

  return (
    <div className={style.block}>
      <div className={style.top}>
        <div className={style.avatar}>
          <img
            src={auth?.profile?.photo || '/images/no_avatar.webp'}
            alt={auth?.username}
            loading="lazy"
            fetchPriority="low"
            width="40"
            height="40"
          />
        </div>
        <div>
          <Reference
            to={NAVIGATION.account.url}
            classes={['md', 'outline']}
            onChange={() => setToggle(false)}
          >
            <span>{t('personal_area')}</span>
            <Icon name={'icon-navigation-chevron-right'} />
          </Reference>
          <p className={style.nickname}>{auth?.username}</p>
        </div>
      </div>
      <div className={style.center}>
        <div className={style.container}>
          <NavLink
            to={NAVIGATION.wallet.url}
            className={style.info}
            onClick={() => setToggle(false)}
          >
            <div className={style.count}>{t('balance')}: <h3>{fixed(auth?.credits?.real_balance)}</h3> {auth?.currency?.text}</div>
            <Icon name={'icon-navigation-chevron-right'} />
          </NavLink>
          <div className={style.actions}>
            <Reference
              to={`${NAVIGATION.wallet.url}/deposit`}
              classes={['primary', 'wide', 'md']}
              placeholder={t('deposit')}
              onChange={() => setToggle(false)}
            />
            <Reference
              to={`${NAVIGATION.wallet.url}/withdrawal`}
              classes={['secondary', 'wide', 'md']}
              placeholder={t('withdrawal')}
              onChange={() => setToggle(false)}
            />
          </div>
        </div>
        <div className={style.container}>
          <NavLink
            to={NAVIGATION.bonuses.url}
            className={
              classNames(
                style.info,
                style.column
              )
            }
            onClick={() => setToggle(false)}
          >
            <div className={style.amount}>
              <div className={style.count}>{t('bonus')}: <h3>{fixed(auth?.credits?.bonus.amount)}</h3> {auth?.currency?.text}</div>
              <Icon name={'icon-navigation-chevron-right'} />
            </div>
            {
              auth?.credits?.bonus.total_bets > 0 &&
              <>
                <div className={style.bonus}>
                  <p>{auth?.credits?.bonus.total_bets} {auth?.currency?.text} ({auth?.credits?.bonus.percentage})%</p>
                  <p>{auth?.credits?.bonus.refund_sum} {auth?.currency?.text}</p>
                </div>
                <div className={style.scale}>
                  <div
                    className={style.value}
                    style={{
                      width: `${auth?.credits?.bonus.percentage}%`,
                    }}
                  />
                </div>
              </>
            }
          </NavLink>
        </div>
        <menu className={style.container}>
          {
            DATA.map((el, idx) =>
              <NavLink
                key={idx}
                to={el.url}
                className={style.link}
                onClick={() => setToggle(false)}
              >
                <Icon
                  name={el.icon}
                  size={'sm'}
                />
                <p>{t(el.text)}</p>
                <Icon name={'icon-navigation-chevron-right'} />
              </NavLink>
            )
          }
        </menu>
      </div>
      <div className={style.bottom}>
        <Button
          classes={['primary', 'wide', 'md']}
          placeholder={t('logout')}
          onChange={deleteAuth}
        />
      </div>
    </div>
  )
}

export default AccountMenu
